import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import OnboardingMain from 'components/onboarding';
import { Page, Section } from 'react-page-layout';
import CmsSection from 'components/cms-placeholder/section';
import staticPath from 'util/misc/static-assets-path';
import FreeDeliveryBatch from 'components/free-delivery-batch';

class Onboarding extends PureComponent {
    static propTypes = {
        setBreadcrumbs: PropTypes.func.isRequired,
        meta: PropTypes.object.isRequired,
        isLoaded: PropTypes.bool.isRequired,
        setMainContentIsLoaded: PropTypes.func.isRequired,
    };

    render() {
        return (
            <Page layout={'full-width-no-container'}>
                <Section slot="content">
                    <div className="page page__onboarding page__compact">
                        <div
                            className={classnames('page--content', {
                                'page--content__is-visible': true,
                            })}
                        >
                            <FreeDeliveryBatch />
                            <OnboardingMain onLoaded={() => this.props.setMainContentIsLoaded({ isLoaded: true })} />
                            <CmsSection type="section" color="accent">
                                <img
                                    className="section--footer-image"
                                    src={staticPath('img/spacer/img-footer-on-purple.png')}
                                />
                            </CmsSection>
                        </div>
                    </div>
                </Section>
            </Page>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        pageName: 'router.name',
        isLoaded: 'main-content.isLoaded',
    }),
    reduxUtils.mapDispatchToProps({
        setBreadcrumbs: 'breadcrumbs.set',
        setMainContentIsLoaded: 'main-content.setIsLoaded',
    })
)(Onboarding);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/templates/onboarding/index.js